import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import trimName from 'utils/trimName';

export default class SurverCategoryFilter extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const { dropdownOpen } = this.state;
    const { title, dropDownItems, handleFilter } = this.props;
    const defaultItem = { name: 'All' };

    return (
      <Dropdown className="d-inline" isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle caret>
          {trimName(title)}
        </DropdownToggle>
        <DropdownMenu className="categories-dropdown-menu" style={{ maxHeight: "15em", overflow: "scroll" }}>
          <DropdownItem onClick={() => handleFilter(defaultItem)}>{defaultItem.name}</DropdownItem>
          {
            dropDownItems.map(item => (
              <DropdownItem onClick={() => handleFilter(item)}>{item.name}</DropdownItem>
            ))
          }
        </DropdownMenu>
      </Dropdown>
    );
  }
}

SurverCategoryFilter.propTypes = {
  title: PropTypes.string,
  dropDownItems: PropTypes.array,
  handleFilter: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/survey-templates/SurveyCategoryFilter.js